import VueSimpleSuggest from '@vojtechlanka/vue-simple-suggest'
import '@vojtechlanka/vue-simple-suggest/style.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueSimpleSuggest', VueSimpleSuggest)
})